import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeAutoObservable } from 'mobx';

import { getInternalSignInPath } from '@/shared/application/utils/auth';
import { MicrofrontendViewModel } from '@/shared/presentation/Microfrontend.vm';

@ViewModel({ singleton: true })
export class LayoutViewModel implements IReactiveModel {
  constructor(private microfrontendViewModel: MicrofrontendViewModel) {
    makeAutoObservable(this);
  }

  @action
  async onInit(props) {
    if (!this.account) {
      setTimeout(() => {
        props.navigate(getInternalSignInPath());
      }, 100);
      return;
    }
  }

  get account() {
    return this.microfrontendViewModel.account;
  }
}
